import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Smartfeed } from '@model/product/smartfeed/smartfeed.model';
import {
  animate,
  animateChild,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-smartfeed',
  templateUrl: './smartfeed.component.html',
  styleUrls: [
    './smartfeed.component.scss',
    '../../user/customer/customer.component.scss',
  ],
  animations: [
    trigger('slide', [
      transition('void => *', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.1s ease-in'),
      ]),
    ]),
    trigger('fade', [
      transition('void => *', [style({ opacity: 0 }), animate(200)]),
    ]),
    trigger('stagger', [
      transition('void => *', [
        query('div', stagger('-.005s ease-in', [animateChild()])),
      ]),
    ]),
  ],
})
export class SmartfeedComponent implements OnInit, OnChanges {
  @Input()
  smartfeed: Smartfeed;

  smartfeedShallow: any;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.smartfeed) {
      this.smartfeedShallow = {
        thingName: this.smartfeed.thingName,
        batteryVoltage: this.smartfeed.batteryVoltage,
        connectionStatus: this.smartfeed.connectionStatus,
        hopperStatus: this.smartfeed.hopperStatus,
        adapterStatus: this.smartfeed.adapterStatus,
        batteriesStatus: this.smartfeed.batteriesStatus,
        firmwareVersion: this.smartfeed.firmwareVersion,
        productVersion: this.smartfeed.productVersion,
        revisionDesired: this.smartfeed.revisionDesired,
        revisionReported: this.smartfeed.revisionReported,
        foodSensorCurrent: this.smartfeed.foodSensorCurrent,
        foodSensorReference: this.smartfeed.foodSensorReference,
        networkRssi: this.smartfeed.networkRssi,
        networkSnr: this.smartfeed.networkSnr,
        connectionStatusTimestamp: this.smartfeed
          .connectionStatusTimestamp,
        createdAt: this.smartfeed.createdAt,
        updatedAt: this.smartfeed.updatedAt,
        deletedAt: this.smartfeed.deletedAt,
        updatedBy: this.smartfeed.updatedBy,
        createdBy: this.smartfeed.createdBy,
        inventory: this.smartfeed.inventory,
        feederId: this.smartfeed.feederId,
        userId: this.smartfeed.userId,
      };
    }
  }
}
